const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站资源支持1080P与4K超高清播放，自适应码率技术根据网络环境智能调节，确保每一帧画面都清晰锐利，带来影院级视觉享受。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '不缓冲秒播',
    desc: '自研极速播放引擎搭配全球CDN加速节点，点击即播无需等待。即使在高峰时段也能保持流畅播放，告别卡顿与缓冲。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量免费资源',
    desc: '收录超10万部影视作品，涵盖国产剧、美剧、韩剧、日剧、动漫、综艺、纪录片等12大分类，每日同步更新最新内容，全部免费观看。',
  },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          平台优势
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-8 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors text-center cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}